import "./SortDropdown.scss";

import PropTypes from "prop-types";

import React from "react";
import { FormattedMessage } from "react-intl";
import * as SearchUtil from "../../../../utils/SearchUtil";
import { trackSelectSortCriteria } from "../../../../utils/SearchTrackingUtil";
import { Dropdown, MenuItem } from "react-bootstrap";
import LocaleUtil from "shared/src/uidispatcherapi/LocaleUtil";

type Props = {
    selectedSortCriteria: {
        [x: string]: any;
    };
    query: {
        [x: string]: any;
    };
    onChangeQuery: Function;
    isMobile?: boolean;
};

class SortDropdown extends React.Component<Props> {
    onSortChange(criteria: string) {
        const currentSort = this.props.query ? this.props.query.sorting : null;
        const selectedSort = SearchUtil.getSelectedSortCriteria(criteria);
        if (currentSort !== selectedSort.CRITERIA) {
            trackSelectSortCriteria(selectedSort.DESCRIPTION);
            const newQuery = Object.assign({}, this.props.query, { sorting: selectedSort.CRITERIA });
            this.props.onChangeQuery(newQuery);
        }
    }

    render() {
        const specifiedSortValue = this.props.selectedSortCriteria;
        return (
            <Dropdown
                id={"sort-articles-by-criteria-dropdown" + (this.props.isMobile ? "-mobile" : "")}
                className="mfcss_pageheader--toolbar-sortby btn-block test-sort-dropdown"
                onSelect={(e: any) => this.onSortChange(e)}>
                <Dropdown.Toggle
                    className="dropdown-toggle-text"
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    block>
                    <FormattedMessage id={specifiedSortValue.I18N_KEY} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <MenuItem header>
                        <FormattedMessage id="EX_SEARCH_SORT_BY_LABEL" />
                    </MenuItem>
                    {Object.values(SearchUtil.SORT_CRITERIA).map((value) => {
                        if (
                            LocaleUtil.isSelectedLanguageSymbolic() &&
                            (value.CRITERIA === "description asc" || value.CRITERIA === "description")
                        ) {
                            return null;
                        } else {
                            return (
                                <MenuItem
                                    key={value.TEST_CSS_CLASS}
                                    eventKey={value.CRITERIA}
                                    className={value.TEST_CSS_CLASS}
                                    active={specifiedSortValue.CRITERIA === value.CRITERIA}>
                                    <FormattedMessage id={value.I18N_KEY} />
                                </MenuItem>
                            );
                        }
                    })}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    static contextTypes = { router: PropTypes.object };
}

export default SortDropdown;

export const { contextTypes } = SortDropdown;
